/**
 * @desc Filter文件
 * @file config.js
 * @author dingzhenyue@baidu.com
 */

import dayjs from 'dayjs';
import {codeTypeMap} from './config';

/**
 * 用户身份
 * @param {String} value 用户身份值
 * @returns 用户身份中文
 */

export const userTypeFilter = value => {
    let data = ['律师', '律所律师'];
    return data[value] || '-';
};

/**
 * 会员类型
 * @param {Number} date 时间戳（s）
 * @returns 日期（2022-10-10）
 */

export const codeTypeFilter = value => {
    if (!value) {
        return '-';
    }
    return codeTypeMap[value] || '-';
};
